import { render, staticRenderFns } from "./select-boolean-field.vue?vue&type=template&id=197f8c1d&"
import script from "./select-boolean-field.vue?vue&type=script&lang=js&"
export * from "./select-boolean-field.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports